import {Component, OnInit, ViewChild, ElementRef, Renderer, AfterViewInit, Input, NgZone, Output, forwardRef} from '@angular/core';
import { EventEmitter } from '@angular/common/src/facade/async';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
declare var MediumEditor: any;

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef( () => EditorComponent),
      multi: true
    }
  ]
})
export class EditorComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  private isValid: boolean;
  @Input() inputText: any;
  @Input() inputClass: string;
  @Input() isRequired: boolean;
  @Output() emitterText: EventEmitter<any> = new EventEmitter <any>();
  @Input() placeHolder: string;
  public propagateChange: any = () => {};
  @ViewChild('editor') elem: ElementRef;
  public value: any;
  content;
  editor;

  constructor( private render: Renderer, private element: ElementRef, private zone: NgZone ) {
    this.isValid = this.isRequired === false;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    const self = this;
    this.editor = new MediumEditor(this.elem.nativeElement, {
      toolbar: {
        buttons: ['bold', 'italic', 'underline', 'anchor', 'h1', 'h2', 'h3', 'h4', 'unorderedlist', 'outdent', 'indent', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
        static: true,
        align: 'left',
        sticky: true,
        updateOnEmptySelection: true

      },
      placeholder: {
        text: this.placeHolder ? this.placeHolder : 'Type your text',
        hideOnClick: false
      }
    });

    this.editor.subscribe('editableInput', function (event, editable) {
      if (self.isRequired) {
        self.isValid = editable.textContent !== undefined && editable.textContent !== null && editable.textContent !== '';
        self.render.setElementClass(editable, 'isValid', self.isValid);
      }
      // self.zone.run(() => {
      self.value = editable.innerHTML;
      self.propagateChange(self.value);
      self.emitterText.emit({
        html: editable.innerHTML,
        event: event,
        editable: editable,
        config: {
          inputClass: self.inputClass,
          isRequired: self.isRequired,
          isValid: self.isValid,
        }
      });
      // });
    });
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
    if (obj) {
      this.value = obj;
      this.editor.setContent(obj);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/editor/editor.component.ts